import axios from "axios";

import { Upload } from "./uploads";
import { Workspace } from "./workspaces";

export interface Patron {
  id: number;
  "last-visited-at": Record<string, number>; // slug -> unix timestamp in seconds
}

export interface CreatePatronRequest {
  slug: string;
}

export interface CreatePatronResponse {
  "oauth-url": string;
}

export const createPatron = async (
  data: CreatePatronRequest,
): Promise<CreatePatronResponse> => {
  return (await axios.post<CreatePatronResponse>("/api/v1/patrons", data)).data;
};

export const getPatron = async (): Promise<Patron> => {
  return (await axios.get<Patron>("/api/v1/patrons/current")).data;
};

export const getPatronEntitlements = async (
  slug: string,
): Promise<Upload[]> => {
  return (await axios.get<Upload[]>(`/api/v1/patrons/entitlements/${slug}`))
    .data;
};

export const getPatronUploadDownloadUrl = (uploadId: number): string => {
  return `/api/v1/patrons/uploads/${uploadId}`;
};

export interface PatronSyncExemption {
  id: number;
  email: string;
  "created-at": string;
}

export const getPatronSyncExemptions = async (
  workspace: Workspace,
): Promise<PatronSyncExemption[]> => {
  return (
    await axios.get<PatronSyncExemption[]>(
      `/api/v1/workspaces/${workspace.id}/patrons/sync-exemptions`,
    )
  ).data;
};

export const addPatronSyncExemption = async (
  workspace: Workspace,
  data: { email: string },
): Promise<void> => {
  await axios.post(
    `/api/v1/workspaces/${workspace.id}/patrons/sync-exemptions`,
    data,
  );
};

export const deletePatronSyncExemption = async (
  workspace: Workspace,
  id: number,
): Promise<void> => {
  await axios.delete(
    `/api/v1/workspaces/${workspace.id}/patrons/sync-exemptions/${id}`,
  );
};

export interface PatronEmailBlock {
  id: number;
  email: string;
  "created-at": string;
}

export const getPatronEmailBlocks = async (
  workspace: Workspace,
): Promise<PatronEmailBlock[]> => {
  return (
    await axios.get<PatronEmailBlock[]>(
      `/api/v1/workspaces/${workspace.id}/patrons/email-blocks`,
    )
  ).data;
};

export const addPatronEmailBlock = async (
  workspace: Workspace,
  data: { email: string },
): Promise<void> => {
  await axios.post(
    `/api/v1/workspaces/${workspace.id}/patrons/email-blocks`,
    data,
  );
};

export const deletePatronEmailBlock = async (
  workspace: Workspace,
  id: number,
): Promise<void> => {
  await axios.delete(
    `/api/v1/workspaces/${workspace.id}/patrons/email-blocks/${id}`,
  );
};
